import React from "react";
import CodeOrg from "assets/images/code_org.svg";

const Card3 = () => {
  return (
    <div
      className="right bg-white pl-[26px]  p-6 sm:w-[393px] relative sm:mt-0 mt-8 sm:rounded-[20px] sm:shadow-card2"
      // style="box-shadow: 0px 6px 10px #00000029; border-radius: 22px;"
    >
      <p className="font-medium text-[18px] font-sans">
        "Efficient and very good customer <br /> service."
      </p>
      <p className="text-[#00173A] font-sans leading-relaxed pt-5">
        The Tomedes team was very responsive <br /> and quick to help us address
        any issues <br /> related to timeline and quality of <br />{" "}
        translation...I would recommend the <br /> Tomedes team to any computer
        science <br /> curriculum providers.
      </p>

      <div className="pt-12">
        <img src={CodeOrg} alt="" />
        <p className="text-[18px] font-medium font-secondary pt-3">
          Jorge Castro
        </p>
      </div>
    </div>
  );
};

export default Card3;
